import { Campaign, Nullable } from '@Models';
import { RequestAction } from '@Repository/RequestAction';
import { RequestCampaignsSuccess } from '@Repository/tool/survey';
import { injectable } from 'inversify';
import { IEntitiesAction } from '@Redux/IEntitiesAction';
import campaignsSlice from '@Redux/reducers/tool/survey/campaigns.slice';

@injectable()
export class CampaignsAction extends IEntitiesAction<
  Campaign,
  RequestCampaignsSuccess
> {
  // TODO
  //@inject(TYPES.Repository.CampaignRepository) private _repository!: CampaignRepository;

  protected fetchDataSuccess(item: Campaign[]): {
    payload: Campaign[];
    type: string;
  } {
    return campaignsSlice.actions.setCampaigns(item);
  }

  protected cacheDataSuccess(item: Campaign[]): {
    payload: Campaign[];
    type: string;
  } {
    return campaignsSlice.actions.setCampaigns(item);
  }

  protected haveError(message: string): { payload: string; type: string } {
    return campaignsSlice.actions.setError(message);
  }

  protected areLoading(bool: boolean): { payload: boolean; type: string } {
    return campaignsSlice.actions.setLoading(bool);
  }

  protected async getItems(): Promise<RequestAction> {
    return new RequestCampaignsSuccess({
      payload: [
        {
          id: '1',
          name: 'Campaign 1',
          description: 'Description 1',
          specialItemQuestions: [],
          unitQuestions: [],
          answers: [],
          isClosed: false,
        },
        {
          id: '2',
          name: 'Campaign 2',
          description: 'Description 2',
          specialItemQuestions: [],
          unitQuestions: [],
          answers: [],
          isClosed: true,
        },
      ],
    });
  }

  protected async getCachedItems(): Promise<Nullable<Campaign[]>> {
    return null;
  }
}
